import {
  classifyValue,
  formatArrayItem,
  formatComparisonValue,
  objectEntries,
} from "./comparisonFormat";

/** Rend une valeur jsonb polymorphe lisible (scalaires / chips array / résumé objet). */
export function ComparisonValue({
  value,
  unit,
  fieldKey,
  locale,
  tooltipPrefix,
}: {
  value: unknown;
  unit: string | null;
  fieldKey: string;
  locale: "fr-CA" | "en-CA";
  tooltipPrefix: string;
}) {
  const kind = classifyValue(value);

  if (kind === "empty") {
    return <span className="text-slate-300">—</span>;
  }

  if (kind === "array") {
    const arr = value as unknown[];
    if (arr.length === 0) return <span className="text-slate-300">—</span>;
    return (
      <span className="flex flex-wrap gap-1">
        {arr.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center rounded bg-slate-100 px-1.5 py-0.5 text-[11px] text-slate-700"
          >
            {formatArrayItem(item)}
          </span>
        ))}
      </span>
    );
  }

  if (kind === "object") {
    const entries = objectEntries(value);
    return (
      <span className="flex flex-col gap-0.5">
        {entries.map((e) => (
          <span key={e.key} className="text-[11px] text-slate-600">
            {/* clé = identifiant extrait → pas d'auto-traduction */}
            <span className="font-medium text-slate-500" translate="no">
              {e.key}:
            </span>{" "}
            {e.display}
          </span>
        ))}
      </span>
    );
  }

  // scalar — 9.S.1 : dispatch via formatComparisonValue (currency/percent/
  // date/number normalisés selon field_key + unit). Fallback strict
  // formatScalar quand kind=text — anti-régression. Tooltip natif title
  // expose la valeur brute pour traçabilité broker.
  const formatted = formatComparisonValue(value, fieldKey, unit, locale);
  const showRawTooltip = formatted.kind !== "text" && formatted.raw.length > 0;
  return (
    <span
      className="break-words tabular-nums"
      title={showRawTooltip ? `${tooltipPrefix}${formatted.raw}` : undefined}
    >
      {formatted.display}
      {!formatted.suppressUnit && unit ? <span className="ml-1 text-slate-400">{unit}</span> : null}
    </span>
  );
}
